import { BoxProps } from '@mui/material';
import React from 'react';
import FlexBox from './flexbox';

const FlexBoxColumn: React.FC<BoxProps> = ({ ...props }) => {
  return <FlexBox flexDirection="column" {...props} />;
};

export default FlexBoxColumn;
